import React, { useContext } from 'react'
import { isUndefined } from 'lodash'

import useTitle from 'common/use-title'

import { ReportContext } from '../ReportContextProvider'

import Mapper from './Mapper'
import EmptyState from './EmptyState'

const ColumnMapper = () => {
  const { columnMappingData, onAddFile } = useContext(ReportContext)
  useTitle('Scoir - Column Mapping')

  if (isUndefined(columnMappingData)) {
    return <EmptyState />
  }

  return (
    <Mapper
      columnMappingData={columnMappingData}
      onAddFile={onAddFile}
    />
  )
}

export default ColumnMapper
